import { validateProductRates } from "../validators";
export const validators = {
    id: (_item, value) => {
        if (typeof value !== "string" || !value.trim()) {
            return "Agency ID is required to update CPMs.";
        }
        return undefined;
    },
    "billingInfo.products": validateProductRates
};
//# sourceMappingURL=validators.js.map